import templateUrl from "emun.auth/verify-email-simple.htm";
import controller from "emun.auth/verify-email-simple.controller";

export default {
  controller,
  templateUrl,
	bindings: {
		registrationUrl: "@",
		loginUrl: "@"
	}
};
